import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  EpimsBankStoreActions,
  EpimsBankStoreSelectors,
  EpimsBankStoreReducer,
} from './index';
import { EpimsBankDto } from '@cradua/data';

@Injectable()
export class EpimsBankFacade {
  constructor(
    private store: Store<EpimsBankStoreReducer.EpimsBankPartialState>
  ) {}

  communityRecord$ = this.store.select(EpimsBankStoreSelectors.getSelected);
  communityRecordError$ = this.store.select(
    EpimsBankStoreSelectors.getEpimsBankError
  );

  getselected() {
    return this.store.select(EpimsBankStoreSelectors.getSelected);
  }

  get isLoadingEpimsBank() {
    this.store.dispatch(EpimsBankStoreActions.loadEpimsBank());
    return this.store.select(EpimsBankStoreSelectors.loadingEpimsBank);
  }

  get loadEpimsBank() {
    this.store.dispatch(EpimsBankStoreActions.loadEpimsBank());
    return this.store.select(EpimsBankStoreSelectors.getAllEpimsBank);
  }

  addEpimsBank(newEpimsBank: EpimsBankDto[]) {
    this.store.dispatch(EpimsBankStoreActions.addEpimsBank({ newEpimsBank }));
  }

  updateEpimsBank(updateEpimsBank: EpimsBankDto[]) {
    this.store.dispatch(
      EpimsBankStoreActions.updateEpimsBank({ updateEpimsBank })
    );
  }

  removeEpimsBank(ids: string[]) {
    this.store.dispatch(EpimsBankStoreActions.removeEpimsBank({ ids }));
  }
}
